import { render, staticRenderFns } from "./BuelkBase.vue?vue&type=template&id=f32561a8"
import script from "./BuelkBase.vue?vue&type=script&lang=js"
export * from "./BuelkBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports